import {Component, signal} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {BusinessType} from './add-business-form-data';

@Component({
  selector: 'app-business-type-select-modal',
  imports: [FormsModule],
  templateUrl: './business-type-select-modal.html'
})
export class BusinessTypeSelectModalComponent {
  selectedType = signal<BusinessType>('individual');

  constructor(public activeModal: NgbActiveModal) {}

  setType(type: BusinessType): void {
    this.selectedType.set(type);
  }

  confirm(): void {
    this.activeModal.close(this.selectedType());
  }
}
